import React from 'react';
import { InfoCircle } from 'react-bootstrap-icons';
import { useTheme } from '../../contexts/ThemeContext';

/**
 * Soft notice for Connect Trade Schwab: balances/P&L refresh overnight, not live.
 */
export default function SchwabPnLInfoBanner({ style }) {
  const { colors } = useTheme();
  const accent = colors.info || '#4299E1';

  return (
    <div
      role="status"
      data-testid="schwab-pnl-info-banner"
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 10,
        marginBottom: 16,
        padding: '10px 12px',
        borderRadius: 8,
        border: `1px solid ${accent}33`,
        backgroundColor: `${accent}0D`,
        color: colors.textMuted || colors.textLight,
        ...style,
      }}
    >
      <InfoCircle
        size={14}
        aria-hidden="true"
        style={{ flexShrink: 0, marginTop: 2, color: accent }}
      />
      <p
        style={{
          margin: 0,
          fontSize: '0.8125rem',
          lineHeight: 1.45,
          color: colors.textMuted || colors.textLight,
        }}
      >
        Account profit and loss updates nightly. Real-time updates are not supported.
      </p>
    </div>
  );
}
